import { assertDataMap, identity } from './utils';
import { withContext } from './withContext';
export function withExtras(extras) {
    if (!assertDataMap(extras, 'extras')) {
        return identity;
    }
    return withContext({ ExtraData: extras });
}
//# sourceMappingURL=withExtras.js.map